<template>
  <div class="rider-confirm-code-wrapper">
    <h1>骑手确认码</h1>
    <go-button>
      <i class="go_icon_add1_outlined"></i>
      primary Button默认态
    </go-button>
    <go-icon-button icon="go_icon_add1_outlined">1231</go-icon-button>
    <go-button>
      <i class="go_icon_add1_outlined"></i>
      {{ $t('FoodB_202412_AFEo_IMDT') }}
    </go-button>
    <go-button size="max">max Button</go-button>
    <go-button :disabled="true">disabled primary禁用态</go-button>
  </div>
</template>
<script setup>
// import Track from '@/utils/track'
import { onMounted } from 'vue'
import { getShopSelfEntryOpenCheck } from './api'
import { requestDataHelper } from '@/utils/request/helper'
onMounted(async () => {
  console.log('-------------------------------- start --------------------------------')
  console.log('-------------------------------- end --------------------------------')
  // Track.testTrack({
  //   eventId: 'sailing_b_m_test_track',
  //   eventLabel: '门店端基座测试埋点',
  //   attrs: {},
  // })
  await requestDataHelper(getShopSelfEntryOpenCheck)
})
</script>
<style lang="scss" scoped>
.rider-confirm-code-wrapper {
  padding: 20px;
}
</style>
